module.exports = __webpack_public_path__ + "img/game-hand.49656cfb.png";